import { CLOSE_PAYMENT, OPEN_PAYMENT } from './constants';
import { PAYMENT_TYPE } from '../../../../main/payment/constants';

export const closePayment = () => ({ type: CLOSE_PAYMENT });

export const openGiftCardPayment = () => ({
  type: OPEN_PAYMENT,
  payload: PAYMENT_TYPE.giftCard,
});

export const openCardPayment = () => ({
  type: OPEN_PAYMENT,
  payload: PAYMENT_TYPE.card,
});

export const openCashPayment = () => ({
  type: OPEN_PAYMENT,
  payload: PAYMENT_TYPE.cash,
});
